import { Box } from '@mui/material'
import React from 'react'
import GetCookie from '../Services/GetCookie';
import Data from '../Data/.json'
import { Variants, motion } from 'framer-motion'

interface Props { }

function TitrePartie(props: { titre: string, whithFont?: true }) {
    const { } = props
    const [mode, setMode] = React.useState(localStorage.getItem('mode'))
    const cookieMode = GetCookie(Data.mode);

    const scroll: Variants = {
        offscreen: {
            x: 30,
            opacity: .5
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: .5
            }
        }
    };
    const scroll2: Variants = {
        offscreen: {
            x: -15,
            opacity: .5
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: .3
            }
        }
    };

    return (
        <>
            <Box gap={1} className='titre' display="flex">
                <motion.div
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: false, amount: 0.8 }}
                    variants={scroll2}
                >
                    <Box width={100} bgcolor={(cookieMode == 'dark' || props.whithFont) ? "rgba(255, 255, 255, .5)" : cookieMode == 'light' ? '#000154' : "rgba(12, 192, 223, .3)"} color={"rgba(255, 255, 255, 0)"}>.</Box>
                </motion.div>

                <motion.div
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: false, amount: 0.8 }}
                    variants={scroll}
                >
                    <label style={{ color: (cookieMode == 'dark' || props.whithFont) ? "white" : cookieMode == 'light' ? '#000154' : "#0cc0df" }} htmlFor="">
                        {props.titre.toUpperCase()}
                    </label>
                </motion.div>


            </Box>
        </>
    )
}

export default TitrePartie
